import realEstateInformationSearchComponent from './real-estate-information-search.component';

const realEstateInformationSearchModule = angular.module('realEstateInformationSearch', [
])
  .component('realEstateInformationSearch', realEstateInformationSearchComponent)
  .name;

export default realEstateInformationSearchModule;
